import React from "react";
import PageSection from "./PageSection";
import img1 from "../assets/d.png";
import img0 from "../assets/doge-computer.png";
import img_tbd from "../assets/enterprise-eth.png";
import img_p from "../assets/medium.png"
import zkp from "../assets/photo_2022-08-17_01-35-09.jpg";

import { FaRocket, FaSatellite, FaRobot, FaMicrochip } from "react-icons/fa";

const Prodcuts = () => {
  const products = [
    {
      id: 0,
      icon: <FaRocket size={50} className="text-white" />,
      title: "#0 Medium Publication ",
      subtitle:
        "Quick look all members' articles list here! There are lots of fantastic posts in our column.",
      link: "https://docs.google.com/spreadsheets/d/12usP8AKKuEwC0YeQ9pbH4MRIt6dZ2AUPjFC0QHd-CGA/edit#gid=0",
      img: img0,
      members: {
        Leader: "Mur**",
        members1: "Killimilli",
      },
    },
    {
      id: 1,
      icon: <FaRocket size={50} className="text-white" />,
      title: "#1 🩺 SmartAggregator Ver.1",
      subtitle:
        "A De-Application with Online Compiler, Dev. Tools. & BOT Package.",
      link: "https://frolicking-nougat-cbc6ab.netlify.app/",
      img: img0,
      members: {
        Leader: "Mur**",
        members1: "Killimilli",
      },
    },
    {
      id: 2,
      icon: <FaMicrochip size={50} className="text-white" />,
      title: "#2 NFT Verification System",
      subtitle:
        "A verification system which can verify whether a NFT is belonged to the user or not.",
      link: "https://mollyy0514.github.io/NFT_Verification_System/",
      img: img0,
      members: {
        Leader: "",
        members1: "",
      },
    },
    {
      id: 3,
      icon: <FaRobot size={50} className="text-white" />,
      title: "#3 Bakajohn",
      subtitle:
        "To promote the good sides of Taiwanese local culture. Here is a limited 500 free mint dynamic NFT(ERC-721) collections deployed on Ethereum.",
      link: "https://bakajohn.com/",
      img: img1,
      members: {
        Leader: "",
        members1: "",
      },
    },
    {
      id: 4,
      icon: <FaSatellite size={50} className="text-white" />,
      title: "#4 ZK Playground Judging System",
      subtitle:
        "Designing the homework and constructing the homework 0 judging dapp system for ZK-Playground(EFGrants).",
      link: "https://github.com/SWF-Lab/ZK-Playground-Judging-System",
      img: zkp,
      members: {
        Leader: "",
        members1: "",
      },
    },
    {
      id: 5,
      icon: <FaSatellite size={50} className="text-white" />,
      title: "#5 TBD",
      subtitle:
        "TBD",
      link: "",
      img: img_tbd,
      members: {
        Leader: "",
        members1: "",
      },
    },
  ];

  return (
    <PageSection
      name="products"
      title="Products"
      subtitle={`Cast an eye over our works!`}
    >
      <div className="grid lg:grid-cols-3 gap-12 text-black ">
        {products.map(({ id, icon, title, subtitle, link, img, members }) => (
          <div
            key={id}
            className="group bg-transparent border-2 border-black rounded-lg flex flex-col items-center justify-center p-4 text-center"
          >
            <a href={link} target="_blank">
              <br />
              <div className="flex items-center justify-center duration-300 group-hover:scale-110">
                <img className="rounded-lg" src={img} width="250" height="100" ></img>
                {/* <div className="bg-black rounded-full p-5 m-4">{icon}</div> */}
              </div>
              <div className="flex items-center justify-center">
                
              </div>
              <h1 className="text-2xl lg:text-2xl my-8 capitalize">{title}</h1>
              <p className="text-lg ">{subtitle}</p>
              <br />
            </a>
          </div>
        ))}
      </div>

    </PageSection>
  );
};

export default Prodcuts;
